module.exports = __webpack_public_path__ + "static/media/schaf.61090195.png";